export default "__VITE_PUBLIC_ASSET__079385f1__"